module.exports = __webpack_public_path__ + "img/amex-small.e2319cb9.svg";